import './TextLink.scss';

import * as React from 'react';
import { Link } from 'gatsby';

type Props = {
  to: string;
  children: React.ReactNode;
};

export default function TextLink(props: Props) {
  return (
    <Link className="TextLink" to={props.to}>
      {props.children}
    </Link>
  );
}
